import { NavItem } from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';
import { INavItem } from 'coreOld/types';
import { hasPermission } from 'router/utils';

import { NavWrapper } from './navigationStyle';
import { navStructure } from './navStructure';

interface IProps {
  isLoggedUser?: boolean;
  openAuthModal?: (type: HeaderModalOptions) => void;
  userResources?: string[];
}

const NavigationView = ({ isLoggedUser, openAuthModal, userResources = [] }: IProps) => {
  return (
    <NavWrapper>
      {navStructure(isLoggedUser, openAuthModal)?.map((item: INavItem, idx) => {
        const displayPermission = hasPermission(item?.permissions, userResources);

        return (
          <NavItem
            key={`${idx}-${item?.name}`}
            url={item?.url}
            onClick={item?.onClick}
            icon={item?.icon}
            text={item?.name}
            matchedPath={item?.matchedPath}
            isTextHidden={item?.isTextHidden}
            display={item?.display && displayPermission}
          />
        );
      })}
    </NavWrapper>
  );
};

export default NavigationView;
